import type { TipoNaBase } from "@bookdental/schemas";

export const ROTULO_DO_TIPO: Record<TipoNaBase, string> = {
  servicos: "Serviços",
  materiais: "Materiais",
  insumos: "Insumos",
  quimicas: "Químicas",
  cores: "Cores",
  equipamentos: "Equipamentos",
  procedimentos: "Procedimentos",
  especialidades: "Especialidades",
};

export const DESCRICAO_DO_TIPO: Record<TipoNaBase, string> = {
  servicos: "O que o laboratório produz, por categoria. A química diz em que materiais cada serviço é feito.",
  materiais: "O que o dentista escolhe no pedido. A química liga o material aos serviços.",
  insumos: "Produtos e consumíveis que o laboratório compra, ligados à química e aos equipamentos.",
  quimicas: "Famílias de material — o eixo que liga serviço, material, equipamento e insumo.",
  cores: "Escalas de cor. As escalas padrão já vêm marcadas no onboarding.",
  equipamentos: "Máquinas por tipo, com as químicas com que trabalham.",
  procedimentos: "Procedimentos da clínica. Um procedimento só, ligado a todas as especialidades em que aparece.",
  especialidades: "Especialidades do CFO. As em destaque aparecem primeiro no onboarding da clínica.",
};

/** Coluna "grupo" muda de nome conforme o tipo. */
export const ROTULO_DO_GRUPO: Record<TipoNaBase, string> = {
  servicos: "Categoria",
  materiais: "Química",
  insumos: "Química",
  quimicas: "Família",
  cores: "Escala",
  equipamentos: "Tipo",
  procedimentos: "Categoria",
  especialidades: "Onboarding",
};
